<template>
  <el-form ref="routeEditForm" label-width="100px"
           :model="route" :rules="rules">
    <el-form-item label="标题" prop="title">
      <el-input v-model="route.title"></el-input>
    </el-form-item>
    <el-form-item label="路由层次">
      <el-radio-group v-model="routeLevel" @change="handleRouteLevelRadioChange">
        <el-radio label="rootRoute">一级路由</el-radio>
        <el-radio label="childRoute">子路由</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="父路由" prop="parentRouteId" v-if="routeLevel==='childRoute'">
      <tree-select v-model="route.parentRouteId"
                   :data="routeTree" :props="treeSelectProps"/>
    </el-form-item>
    <el-form-item label="路径" prop="path">
      <el-input v-model="route.path"></el-input>
    </el-form-item>
    <el-form-item label="是否需要授权">
      <el-switch v-model="route.isRequiredAuth" class="switch"
                 active-color="#13ce66" inactive-color="#ff4949"
                 active-text="是" inactive-text="否"
                 @change="handleSwitchChange">
      </el-switch>
    </el-form-item>
    <el-form-item v-if="route.isRequiredAuth" label="路由分类" prop="category">
      <el-select v-model="route.category" placeholder="请选择">
        <el-option v-for="category in routeCategory.getCategories()"
                   :key="category.key" :label="category.value" :value="category.key"/>
      </el-select>
    </el-form-item>
    <el-form-item label="是否为菜单">
      <el-switch v-model="route.isMenu" class="switch"
                 active-color="#13ce66" inactive-color="#ff4949"
                 active-text="是" inactive-text="否">
      </el-switch>
    </el-form-item>
    <el-form-item v-if="route.isMenu" label="菜单序号">
      <el-input-number v-model="route.menuIndex" controls-position="right" :min="1"/>
    </el-form-item>
    <el-form-item v-if="route.isMenu" label="菜单徽章">
      <el-input v-model="route.menuBadge"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button @click="handleCancelBtnClick">取 消</el-button>
      <el-button type="primary" @click="handleConfirmBtnClick">确 定</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {noticeManager} from "@zhoujianhui/vip-core"
import Route from "../model/Route"
import routeCategory from "../model/route-category"
import routeService from "../service/route-service"
import TreeSelect from "../component/TreeSelect"

export default {
  name: "RouteEdit",
  components: {TreeSelect},
  props: {
    editedRoute: Object,
    routeTree: Array
  },
  data() {
    return {
      route: Object.assign({}, this.editedRoute),
      // 根据待编辑路由是否有父路由判断是否是根路由
      routeLevel: this.editedRoute.parentRouteId === null ? "rootRoute" : "childRoute",
      // routeLevel为子路由时显示的路由树选择器的配置项
      treeSelectProps: {
        key: "id",
        label: "title",
        children: "children"
      },
      routeCategory: routeCategory,
      rules: Route.getRules(this)
    }
  },
  methods: {
    handleRouteLevelRadioChange(routeLevel) {
      // 如果选择从子路由变为父路由，要清除子路由可能选择的父路由ID
      if (routeLevel === "rootRoute") {
        this.route.parentRouteId = null
      }
    },
    /**
     * 根据是否需要授权设置路由分类
     * @param isRequiredAuth
     */
    handleSwitchChange(isRequiredAuth) {
      if (isRequiredAuth) {
        this.route.category = this.route.category || routeCategory.getDefaultCategory().key
      } else {
        this.route.category = ""
      }
    },
    handleCancelBtnClick() {
      this.$emit("close")
    },
    handleConfirmBtnClick() {
      this.$refs["routeEditForm"].validate(async (valid) => {
        if (valid) {
          const result = await routeService.editRoute(this.route)

          if (result.isSuccess()) {
            const isReloadRouteTree = true
            this.$emit("close", isReloadRouteTree)
          }

          noticeManager.showMessage(result.msg, result.type)
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.switch) {
  /* switch按钮样式 */
  .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }

  /*打开时文字位置设置*/
  .el-switch__label--right {
    z-index: 1;
  }

  /* 调整打开时文字的显示位子 */
  .el-switch__label--right span {
    margin-left: -4px;
  }

  /*关闭时文字位置设置*/
  .el-switch__label--left {
    z-index: 1;
  }

  /* 调整关闭时文字的显示位子 */
  .el-switch__label--left span {
    margin-left: 18px;
  }

  /*显示文字*/
  .el-switch__label.is-active {
    display: block;
  }

  /* 调整按钮的宽度 */
  .el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 80px !important;
    margin: 0;
  }
}
</style>